import { useState } from "react";
import { altText } from "../Shingles/imageAlts";
import styled from "@emotion/styled"

const ColorSelector = styled.label`
  cursor: pointer;
  display: inline-flex;
  margin-bottom: 1em;
  margin-right: 0.375em;
  position: relative;


  &:after {
    border: 3px solid transparent;
    bottom: 0;
    content: "";
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 0.15s ease-in-out;
  }

  &:hover, &.active {
    &:after {
      border-color: #D40F7D;
    }
  }

  .colorTooltip {
    display: "inline-flex";
    position: absolute;
    bottom: -38px;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    text-align: center;
    font-size: 14px;
    color: #333;
    padding: 5px;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.25);
    min-width: 100px;
    white-space: nowrap;
    z-index: 10;

    &:before {
      content:'';
      display:block;
      width:0;
      height:0;
      position:absolute;
      border-left: 8px solid transparent;
      border-bottom: 8px solid white;
      border-right:8px solid transparent;
      top:-8px;
      left:50%;
      transform: translateX(-50%);
    }
  };
`;

const ColorInput = styled.input`
  display: none;
`;

const ColorImage = styled.img`
  height: 45px;
  width: 45px;
`;

const ColorSwatch = ({ colorData, name, selected, tracking, tabIndex }) => {
  const classes = selected ? "active" : null;
  const [showToolTip, setShowToolTip] = useState(false);

  const hoverEvent = () => {
    setShowToolTip(!showToolTip);
  };

  return (
    <ColorSelector
      tabIndex={tabIndex}
      className={classes}
      data-effect="solid"
      data-tip={colorData.name}
      htmlFor={`shingle-color-${colorData.uid}`}
      {...tracking}
      onMouseEnter={hoverEvent}
      onMouseLeave={hoverEvent}
    >
      <ColorImage
        alt={altText(colorData, 'swatch', 'en', colorData.name)}
        src={colorData.swatch_160x160_url}
      />
      <ColorInput id={`shingle-color-${colorData.uid}`} name={name} type="radio" value={colorData.uid} />
      {showToolTip &&
        <span className="colorTooltip" showToolTip={showToolTip}>{colorData.name}</span>
      }

    </ColorSelector>
  );
};

export default ColorSwatch;
